<template>
  <!-- record -->
  <div class="receipt" style="font-family: '微软雅黑';">
    <div class="page" id='record-title'>
      <!-- 处方信息 -->
      <div style="font-size: 8pt; line-height: 16pt;">
        <p style="float: left;">NO.{{record.inquiryInfo.recordId}}</p>
        <div style="float: right;">
          <p style="float: right;">
            <span tdata="pageNO" format="#">##</span>/<span tdata="pageCount" format="#">##</span>
          </p>
          <p style="width:24pt;float: right; text-align:center;height: 14pt;line-height: 14pt;border:1pt solid rgba(51,51,51,1);border-radius:4px;margin-right: 8pt;">普通</p>
        </div>
      </div>
      <div style="clear: both;"></div>
      <h3  style="text-align: center; font-size: 16pt;margin-top: 0px;font-family: '微软雅黑';font-weight: normal;">{{$store.state.global.countInfo.hospitalName}}</h3>
      <h4 style="text-align: center; font-size: 12pt;margin-top: -14pt;font-family: '微软雅黑';font-weight: normal;">门诊病历</h4>
      <div class="user-info" style="font-size: 9pt;margin-top: -8pt;font-family: '微软雅黑';">
        <div style="width: 100%; border-bottom: 1pt solid #999; line-height: 24pt;">
          <div style="float:left; width: 33.33%">
            姓名：{{record.patient.patientName}}
          </div>
          <div style="float:left; width: 33.33%">
            性别： {{gender}} 
          </div>
          <div style="float:left; width: 33.33%">
            年龄：
            <span v-if="record.inquiryInfo.clinicalAge">{{record.inquiryInfo.clinicalAge}}</span>
            <span v-else>
              <span v-if="record.patient.year > 0">{{record.patient.year}}岁</span>
              <span v-if="record.patient.month > 0 && record.patient.year >= 0 && record.patient.year < 5">{{record.patient.month}}月</span>
              <span v-if="record.patient.year === 0 && record.patient.day > 0">{{record.patient.day}}天</span>
            </span>
          </div>
          <div style="clear: both;"></div>
        </div>
        <div style="width: 100%;border-bottom: 1pt solid #999; line-height: 24pt;">
          <div style="float:left; width: 33.33%">
            手机号：{{record.patient.phoneNo}}
          </div>
          <div style="float:left; width: 33.33%">
            科室：{{laboratoryName}}
          </div>
          <div style="float:left; width: 33.33%">
            就诊日期：{{record.inquiryInfo.modle === 3 ? record.inquiryInfo.clinicalTime : record.inquiryInfo.createDate ? record.inquiryInfo.createDate.slice(0, 10) : ''}}
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>
    </div>
    <!-- 处方 -->
    <div class="page" id="record-body">
      <div class="other-info" style="font-size: 9pt;line-height:1.8;font-family: '微软雅黑';">
        <div>
          主诉：{{record.inquiryInfo.symptom}}
        </div>
        <div>
          现病史：{{record.inquiryInfo.presentIllness}}
        </div>
        <div>
          过敏史：{{record.inquiryInfo.allergyHistory}}
        </div>
        <div>
          既往史：{{record.inquiryInfo.previousHistory}} &nbsp;&nbsp;
          个人史：{{record.inquiryInfo.personalHistory}} &nbsp;&nbsp;
          家族史：{{record.inquiryInfo.familyHistory}}
        </div>
        <div>
          体格检查：
          <span v-if="record.inquiryInfo.temperature" style="margin-right: 6pt;">体温{{record.inquiryInfo.temperature}}℃</span>
          <span v-if="record.inquiryInfo.weight" style="margin-right: 6pt;">体重{{record.inquiryInfo.weight}}kg </span>
          <span v-if="record.inquiryInfo.heartRate" style="margin-right: 6pt;">心率{{record.inquiryInfo.heartRate}}bpm</span>
          <span v-if="record.inquiryInfo.sbp" style="margin-right: 6pt;">血压{{record.inquiryInfo.sbp}}/{{record.inquiryInfo.dbp}}mmHg</span>
          <span v-if="record.inquiryInfo.otherPhysique">{{record.inquiryInfo.otherPhysique}}</span>
        </div>
        <div>
          临床诊断：{{record.inquiryInfo.diagnosisResultString}}
        </div>
      </div>
      <!-- 检查治疗项 -->
      <div class="" style="margin-top: 16pt;font-size: 9pt;font-family: '微软雅黑';" v-if="record.examList && record.examList.length > 0">
        <div style="border-bottom: 1pt solid #999;font-size: 9pt;font-weight: blod;line-height:1.4;">检查治疗项：</div>
        <div style="font-size: 9pt;margin-top: 8pt;line-height: 1.8;">
          <div style="width: 50%;float: left;text-align: left;" v-for="(item) in record.examList" :key="item.examId">
            {{item.examName}} {{item.total}}次
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
      
      <!-- 成药处方 -->
      <div style="margin-top: 16pt;font-size: 9pt;font-family: '微软雅黑';">
        <div v-for="(item, index) in record.medicineDrugPrescriptionList" :key="index + 'medicine'">
          <div style="border-bottom: 1pt solid #999;font-size: 9pt;font-weight: blod;line-height:1.4;">成药处方{{index + 1}}：</div>
          <div style="font-size: 9pt;margin-top: 8pt; width: 100%;">
            <div class="item" v-for="(it, idx) in item.patientDrugList" :key="it.drugId" style="line-height:1.8;">
              <div class="drug" >
                <span style="float:left; width: 50%;">
                  {{idx+1}}、{{it.drugName}}
                </span>
                <span style="float:left; width: 30%;">
                  {{it.specification}}
                </span>
                <span style="float:left; width: 20%;">
                  {{it.totalDosage}} {{it.totalDosageUnit}}
                </span>
              </div>
              <div style="clear:both;"></div>
              <div class="use" style="margin-left: 16pt;">
                <span style="float:left;">用法：{{it.dosage}} {{it.dosageUnit}}/次</span>
                <span style="float:left; margin-left:16pt;">{{it.usage}}</span>
                <span style="float:left; margin-left:16pt;">{{it.frequency}}</span>
              </div>
              <div style="clear:both;"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 饮片处方 -->
      <div style="margin-top: 16pt;font-size: 9pt;font-family: '微软雅黑';">
        <div v-for="(item, index) in record.patientChineseDrugList" :key="index + 'chinese'" style="margin-top: 5pt;">
          <div style="border-bottom: 1pt solid #999;font-size: 9pt;font-weight: blod;line-height:1.4;">饮片处方{{index + 1}}：</div>
          <div style="font-size: 9pt;margin-top: 8pt; width: 100%;overflow: hidden">
            <div class="item" v-for="it in item.patientChineseDrugPiecesList" :key="it.drugId" style="float: left; width: 33.33%;line-height:1.8;">
              {{it.drugName}} {{it.value}} {{it.unit}}
              <span v-if="it.comment">({{it.comment}})</span> 
            </div>
          </div>
          <div style="clear: both;display: block;height: 0;visibility: hidden;"></div>
          <div style="margin-top: -5pt;">
            <div style="overflow: hidden">
              <h4 style="float: left;margin-right: 8pt;font-size: 11pt;font-weight: blod;line-height: 12pt;height: 12pt;">共{{item.totalDosage}}剂</h4>
              <div style="float: left;margin-right:8pt;margin-top: 14pt;line-height: 12pt;height: 12pt;"> 用量：{{item.frequency}}</div>
              <p style="float: left;line-height: 12pt;height: 12pt;margin-top: 14pt;">每日{{item.dailyDosage}}剂</p>
            </div>
            <div style="clear: both;display: block;height: 0;visibility: hidden;"></div>
            <div style="margin-top: -10pt;">
               用法：{{item.usage}}；<span style="margin-left:8pt;">{{item.requirement}}</span>
            </div>
          </div>
          <div style="clear: both;display: block;height: 0;visibility: hidden;"></div>
        </div>
      </div>
      
      <!-- 输液处方 -->
      <div style="margin-top: 16pt;font-size: 9pt;font-family: '微软雅黑';">
        <div  v-for="(item, index) in record.patientInfusionList" :key="item.prescription">
          <div style="border-bottom: 1pt solid #999;font-size: 9pt;font-weight: blod;line-height:1.4;">输液处方{{index + 1}}：</div>
          <div style="font-size: 9pt;margin-top: 8pt; width: 100%;">
            <div class="group" v-for="(it, idx) in item.patientInfusionGroupList" :key="item.id + idx">
              <div>组{{idx + 1}}：</div>
              <div class="drug" v-for="(i) in it.patientDrugList" :key="i.drugId" style="line-height:1.8;">
                <span style="width: 40%;float:left;">{{i.drugName}}</span>
                <span style="width: 30%;float:left;">{{i.specification}}</span>
                <span style="width: 10%;float:left;">{{i.totalDosage}} {{i.totalDosageUnit}}</span>
                <span style="width: 20%;float:left;text-align: right;">{{i.dosage}}{{i.dosageUnit}}/次</span>
              </div>
              <div style="clear: both;"></div>
              <div style="">
                <span style="float:left;margin-left:16pt;">用法：{{it.usage}}</span>
                <span style="margin-left: 8pt;float:left;">{{it.useRate}}</span>
                <span style="margin-left: 8pt;float:left;">x{{it.dayCount}}天</span>
              </div>
              <div style="clear:both;"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 贴敷处方 -->
      <div style="margin-top: 16pt;font-size: 9pt;font-family: '微软雅黑';">
        <div v-for="(item, index) in record.patientStickingDrugGroupList" :key="index + 'sticking'">
          <div style="border-bottom: 1pt solid #999;font-size: 9pt;font-weight: blod;line-height:1.4;">贴敷处方{{index + 1}}：</div>
          <div style="font-size: 9pt;margin-top: 8pt; width: 100%;line-height:1.8;">
            <div class="item" v-for="(it) in item.patientStickingDrugList" :key="it.drugId" style="float: left;width: 33.333%;margin-right: 8pt;">
              {{it.drugName}}&nbsp;&nbsp;{{it.dosage}}{{it.dosageUnit}}
            </div>
            <div style="clear: both;"></div>
          </div>
          <div style="margin-top: 4pt;border-top: 1pt #999 dashed;">
            <div style="width: 100%;clear: both;line-height: 0.6;">
              <p style="float:left;width:25%;">用法：{{item.usage}}</p>
              <p style="float:left;width:25%;">调法：{{item.adjusting}}</p>
              <p style="float:left;width:25%;">时长：{{item.minuteNumber}}分钟</p>
              <p style="float:left;width:25%;">贴数：{{item.count}}贴</p>
            </div>
            <div style="line-height: 0.8;">
              部位：{{item.position | joinArr}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 诊所信息 -->
    <div style="margin-top: 0px;font-size: 9pt;font-family: '微软雅黑';" id="footer-info-record">
      <div style="font-size: 9pt;border-bottom: 1pt solid #999;font-family: '微软雅黑';">
        <div style="">
          医嘱：{{record.inquiryInfo.doctorAdvice}}
        </div>
      </div>
      <div style="font-size: 9pt;margin-top:4pt;font-family: '微软雅黑';">
        <div style="float: left; width: 49.99%;">
          打印时间：{{printTime}}
        </div>
        <div style="float: left; width: 49.99%;">
          医生：{{record.realName}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { getLodop } from '@/plugins/LodopFuncs.js';

export default {
 /** 
  *  type 的几种类型
  *  medicine -> 成药
  *  pieces -> 饮片
  *  infusion -> 输液
  *  apply -> 服帖
  *  infusionCard -> 输液卡
  *  other -> 其他
 */
  props: {
    record: {
      type: Object,
      default: {},
    },
    isReview: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      printConfig: {
        printDoctorName: 0, // 是否打印名字
        printTotalPrice: 0, // 是否显示价格
        remark: 0, // 打印备注
      },
      printTime: '',
      curType: 'record'
    }
  },
  methods: {
    print({isReview} = {}) {
      this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      const { medicalRecordValue } = this.$store.state.global.printConfig;
      const LODOP = getLodop();
      LODOP.SET_LICENSES("","94E6E7FFD51B8CCBE5F216686981579D","C94CEE276DB2187AE6B65D56B3FC2848","");
      this.$nextTick(() => {
        LODOP.PRINT_INIT('病历打印');
        LODOP.SET_PRINT_PAGESIZE(1, '148mm', '210mm', 'record');
        LODOP.ADD_PRINT_HTM(0, '5%', '90%', '50mm', document.getElementById('record-title').innerHTML);
        LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
        LODOP.SET_PRINT_STYLEA(0, "Vorient",3);	
        LODOP.ADD_PRINT_HTM('50mm', '5%','90%', '130mm', document.getElementById('record-body').innerHTML);
        LODOP.ADD_PRINT_HTM('190mm', '5%', '90%', '50mm', document.getElementById('footer-info-record').innerHTML)
        LODOP.SET_PRINT_STYLEA(0,"ItemType",1);
        LODOP.SET_PRINT_STYLEA(0,"LinkedItem",1);	
        LODOP.SET_PRINT_MODE("RESELECT_PAGESIZE", true); // 可以自行修改打印尺寸
        LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); // 打印后自动关闭预览窗口
        // LODOP.NewPageA();
        LODOP.SET_PRINTER_INDEX(medicalRecordValue);
        LODOP.PREVIEW();
        if (isReview) {
          LODOP.PREVIEW();
        }
        LODOP.PRINT();
      });
    },
    // 计算金额
    drugAmt(price, num) {
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return '0.00';
      return BN(price).multipliedBy(num).toFixed(3);
    },
    // 获取打印配置
    getPrintConfig() {
      this.$api.clinicManagement.getPrintConfit({configType: 6}).then((res) => {
        this.printConfig = res;
      });
    },
    scriptInfo(index) {
      return this.curType + '-info' + index;
    },
    idAdd(index) {
      return this.curType + index;
    }
  },
  computed: {
    laboratoryName() {
      return this.$store.state.global.countInfo.laboratoryName;
    },
    gender() {
      if (this.record.patient.gender == 0) return '女';
      if (this.record.patient.gender == 1) return '男';
      return '未知'
    }
  },
  filters: {
    joinArr(arr) {
      let result = '';
      try {
        JSON.parse(arr);
        result = JSON.parse(arr).join(',');
      } catch(e) {

      }
      return result;
    },
  },
  mounted() {
    this.getPrintConfig();
  }
}
</script>
<style lang="scss" scoped>
.header-info {
  border-bottom: 2px solid #000000;
}

.receipt {
  width: 300px;
  justify-content: space-between;
}
span {
  display: inline-block;
  width: 16pt;
  height: 16pt;
  background: #AAAAAA;
}

.receipt {
  position: fixed;
  border: 1pt solid #000000;
  z-index: 100;
  width: 1000px;
  background: white;
  left: -5000px;
  top: 100px;
}
</style>

